<mat-form-field class="w-100" subscriptSizing="dynamic">
    <input
        #userGraphInput
        type="text"
        placeholder="Search for a user"
        matInput
        [formControlName]="controlName()"
        [matAutocomplete]="auto"
        (input)="filter()"
        (focus)="filter()"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="ownerDisplayFn" requireSelection>
        @for (user of users$ | async; track user.id) {
            <mat-option [value]="user">{{ user.displayName }}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
